/**
 * Methods to enter/exit fullscreen mode.
 *
 * The toggle will only have an effect if the current route and screen
 * support fullscreen mode (via $route.meta.allowFullscreen).
 *
 * Depends on:
 *   - this.fullscreenMode (Boolean): Synced to the $store.
 *   - this.$route
 *   - this.$vuetify.breakpoint
 */

export default {
  computed: {
    fullscreenMode: {
      get() {
        return this.$store.state.common.fullscreenMode;
      },
      set(flag) {
        this.$store.commit('SET_FULLSCREEN_MODE', flag);
      },
    },
    canEnterFullscreenMode() {
      return (
        !this.fullscreenMode &&
        this.$vuetify.breakpoint.lgAndUp &&
        this.$route.meta.allowFullscreen
      );
    },
    canExitFullscreenMode() {
      return (
        !!this.fullscreenMode &&
        this.$vuetify.breakpoint.lgAndUp &&
        this.$route.meta.allowFullscreen
      );
    },
  },
  methods: {
    enterFullscreen() {
      if (this.canEnterFullscreenMode) {
        this.fullscreenMode = true;
      }
    },
    exitFullscreen() {
      if (this.canExitFullscreenMode) {
        this.fullscreenMode = false;
      }
    },
    toggleFullscreen() {
      if (!this.fullscreenMode) {
        this.enterFullscreen();
      } else {
        this.exitFullscreen();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/fullscreenMode.js